var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 44,
    height: 24,
    fill: "#1A2A52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 6,
    height: 6,
    fill: "#C9A227"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 36,
    width: 6,
    height: 6,
    fill: "#C9A227"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 36,
    width: 6,
    height: 6,
    fill: "#C9A227"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 6,
    height: 8,
    fill: "#4A5A82"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 46,
    width: 6,
    height: 8,
    fill: "#4A5A82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30 V12",
    stroke: "#1A2A52",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12 L46 17 L30 22 Z",
    fill: "#C9A227"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 62,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fontWeight: "bold",
    fill: "#C9A227",
    textAnchor: "middle"
  }, "IPO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpo);
export default __webpack_public_path__ + "static/media/ipo.1b2aa14198b5834e00cc8107448d0737.svg";
export { ForwardRef as ReactComponent };